export default __webpack_public_path__ + "static/media/TeraBit.45656949.png";